import { useState } from "react";
import { Button, Checkbox, Grid, GridItem, HStack, Text } from "@chakra-ui/react";
import { useUpdateUser, useUserData } from "../../../api/UserApi";

const NotificationsTab = () => {
  const { data: currentUser } = useUserData();
  const [smsNotifications, setSmsNotifications] = useState(currentUser?.smsNotifications);
  const { mutate: updateUser, isPending } = useUpdateUser();

  const onButtonPress = () => {
    updateUser({ ...currentUser, smsNotifications });
  };

  return (
    <>
      <Grid mt={20} templateColumns="repeat(3, 1fr)">
        <GridItem textStyle={"h5"}>Type of notifications</GridItem>
        <GridItem colSpan={2} backgroundColor="darkBlue2.900" p="24px" borderRadius="16px">
          <Grid gap={4}>
            <HStack>
              <Text textStyle={"smBold"} flex={1}>
                SMS Notifications
              </Text>
              <Checkbox
                isDisabled={isPending}
                colorScheme="brandYellow"
                isChecked={smsNotifications}
                onChange={() => setSmsNotifications(!smsNotifications)}
              />
            </HStack>
          </Grid>
        </GridItem>
      </Grid>
      <HStack mt={6} justify={"flex-end"}>
        <Button
          onClick={onButtonPress}
          colorScheme="brandYellow"
          textColor="brandBlue.800"
          isDisabled={isPending}
        >
          Save changes
        </Button>
      </HStack>
    </>
  );
};

export default NotificationsTab;
